import {
  ReportFilters,
  ReportInput,
} from '@totem/components/controlSystemReport/parameterTypes';
import { Filter } from '@totem/types/common';
import { isNotNull } from '@totem/utilities/common';

export const buildReportFilters = (input: ReportInput) => {
  const paramFilters: Filter[] = [];

  if (isNotNull(input.regionId) && input.regionId.length > 0) {
    paramFilters.push({
      field: 'region.id',
      values: input.regionId,
    });
  }
  if (isNotNull(input.buildingId) && input.buildingId.length > 0) {
    paramFilters.push({
      field: 'building.id',
      values: input.buildingId,
    });
  }
  if (isNotNull(input.controlSystemId) && input.controlSystemId.length > 0) {
    paramFilters.push({
      field: 'id',
      values: input.controlSystemId,
    });
  }
  if (isNotNull(input.name) && input.name.length > 0) {
    paramFilters.push({
      field: 'name',
      values: input.name,
    });
  }
  if (isNotNull(input.type) && input.type.length > 0) {
    paramFilters.push({
      field: 'systemType',
      values: input.type,
    });
  }
  if (isNotNull(input.vendor) && input.vendor.length > 0) {
    paramFilters.push({
      field: 'manufacturer',
      values: input.vendor,
    });
  }
  if (isNotNull(input.operatingSystem) && input.operatingSystem.length > 0) {
    paramFilters.push({
      field: 'operatingSystem',
      values: input.operatingSystem,
    });
  }
  if (isNotNull(input.searchName) && input.searchName.trim() !== '') {
    paramFilters.push({
      field: 'name',
      operator: 'cscontains',
      values: [input.searchName],
    });
  }

  return paramFilters;
};

export const addReportFilters = (
  currentFilters: Filter[],
  input: ReportFilters,
) => {
  if (typeof input !== 'undefined') {
    if (isNotNull(input.regionId) && input.regionId.length > 0) {
      currentFilters.push({
        field: 'region.id',
        values: input.regionId,
      });
    }
    if (isNotNull(input.buildingId) && input.buildingId.length > 0) {
      currentFilters.push({
        field: 'building.id',
        values: input.buildingId,
      });
    }
    if (isNotNull(input.controlSystemId) && input.controlSystemId.length > 0) {
      currentFilters.push({
        field: 'id',
        values: input.controlSystemId,
      });
    }
    if (isNotNull(input.vendor) && input.vendor.length > 0) {
      currentFilters.push({
        field: 'manufacturer',
        values: input.vendor,
      });
    }
    if (isNotNull(input.name) && input.name.length > 0) {
      currentFilters.push({
        field: 'name',
        values: input.name,
      });
    }
    if (isNotNull(input.type) && input.type.length > 0) {
      currentFilters.push({
        field: 'systemType',
        values: input.type,
      });
    }
    if (isNotNull(input.operatingSystem) && input.operatingSystem.length > 0) {
      currentFilters.push({
        field: 'operatingSystem',
        values: input.operatingSystem,
      });
    }
  }

  return currentFilters;
};
